<template>
  <div class="page-title">
    <div style="flex: 18">
      <span> {{ t($route.meta.title) }}</span>
      <slot v-if="$slots.btn" name="btn"></slot>
    </div>
    <slot v-if="$slots.subject" name="subject"></slot>
    <slot v-if="$slots.back" name="back"></slot>
  </div>
</template>
<script>
  import t from '../../lang'
  export default {
    data() {
      return {}
    },
    created() {},
    methods: {
      t: t
    }
  }
</script>
<style lang="less" scoped>
  .page-title {
    width: 100%;
    padding: 16px;
    font-size: 24px;
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    align-items: center;
    background: #f6f7fa;
    span {
      color: #1d1f24;
      font-weight: 500;
    }
    .goback {
      cursor: pointer;
      margin-right: 20px;
      font-size: 16px;
      color: #333;
      &:hover {
        color: @primary-color;
      }
    }
  }
</style>
